const CORE_TEXTBOOK_TEXT = 'One or a few core textbook(s)';

export { CORE_TEXTBOOK_TEXT };
